import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deleteModalRecoil,
  alarmCorrectionModifyModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import Pagenation from '@/component/Pagenation';
import SearchBtn from '@/component/SearchBtn';
import DeleteModal from '@/modal/DeleteModal';
import LabelType1 from '@/component/LabelType1';
import { DeviceApi } from '@/sdk/DeviceApi';
import {
  DeviceControllerGetHistoryParams,
  ChangeHistoryDtoRx,
} from '@/sdk/data-contracts';
import { deviceSettingChangeHistoryListRecoil } from '@/atom/DeviceAtom';
import AlarmCorrectionModifyModal from '@/modal/AlarmCorrectionModifyModal';

const SettingChangeHistory = () => {
  const { id } = useParams<{ id: string }>();
  const deviceApi = new DeviceApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const [deleteModalState, setDeleteModalState] =
    useRecoilState(deleteModalRecoil);
  const [alarmCorrectionModifyModalState, setAlarmCorrectionModifyModalState] =
    useRecoilState(alarmCorrectionModifyModalRecoil);
  const [
    deviceSettingChangeHistoryListState,
    setdeviceSettingChangeHistoryListState,
  ] = useRecoilState(deviceSettingChangeHistoryListRecoil);

  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [sortBy, setSortBy] = useState<string>('createdAt');
  const [order, setOrder] = useState<string>('desc');
  const [listLength, setListLength] = useState<number>(0);

  const downloadCSV = async (saveFileName: string) => {
    let allList: ChangeHistoryDtoRx[] | undefined;

    const dto: DeviceControllerGetHistoryParams = {
      id: Number(id),
      sortBy,
      order,
    };

    try {
      const { data } = await deviceApi.deviceControllerGetHistory(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      if (data.changeHistory) allList = data.changeHistory;
    } catch (err: any) {}

    if (!allList || allList.length === 0) {
      setErrorModalText('다운로드할 데이터가 없습니다.');
      return;
    }

    const headers = [
      'No',
      '일시',
      '변경자',
      '교정값',
      '알림값',
      'SMS 수신주기',
    ];

    const rows = allList.map((list, index) => [
      index + 1,
      list.createdAt,
      list.changer,
      list.calibrationValue,
      list.notificationValue,
      `${list.receptionCycle}시간`,
    ]);

    const csvContent = [
      headers.join(','),
      ...rows.map((row) => row.join(',')),
    ].join('\n');

    const bom = '\uFEFF';
    const csvWithBom = bom + csvContent;

    const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${saveFileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const filterDeviceSettingChangeHistoryList = async () => {
    const dto: DeviceControllerGetHistoryParams = {
      id: Number(id),
      offset,
      limit,
      sortBy,
      order,
    };

    try {
      const { data } = await deviceApi.deviceControllerGetHistory(dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      if (data.changeHistory)
        setdeviceSettingChangeHistoryListState(data.changeHistory);
      if (data.totalColumn) {
        setListLength(data.totalColumn);
      } else if (data.totalColumn === 0) {
        setListLength(0);
      }
    } catch (err: any) {}
  };

  const handleLimitChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLimit(Number(e.target.value));
    setOffset(0);
  };

  const handleOffsetChange = (value: number) => {
    setOffset((value - 1) * limit);
  };

  useEffect(() => {
    filterDeviceSettingChangeHistoryList();
  }, [limit, offset]);

  return (
    <>
      <TabCntBox>
        <TableOpitonBox>
          <h1>
            전체 <span>{listLength.toLocaleString()}</span>
          </h1>
          <div className="right-box">
            <IS.SelectType1>
              <select
                value={limit}
                onChange={handleLimitChange}
                className="selected"
                style={{ width: 153 }}
              >
                <option value={10}>10개씩 보기</option>
                <option value={20}>20개씩 보기</option>
                <option value={30}>30개씩 보기</option>
                <option value={50}>50개씩 보기</option>
              </select>
              <span className="img-box">
                <img src="/img/arrow_bottom_555.svg" alt="" />
              </span>
            </IS.SelectType1>
            <BS.Btn1Type5
              type="button"
              onClick={() => downloadCSV('setting_change_history_list')}
            >
              Excel 다운로드
              <span className="img-box">
                <img src="/img/ico_down_fff.svg" alt="" />
              </span>
            </BS.Btn1Type5>
            {/* <BS.Btn1Type5
              type="button"
              onClick={() => setAlarmCorrectionModifyModalState(true)}
            >
              알림/교정값 수정
            </BS.Btn1Type5> */}
          </div>
        </TableOpitonBox>
        <TableBox>
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>일시</th>
                <th>변경자</th>
                <th>교정값</th>
                <th>알림값</th>
                <th>SMS 수신주기</th>
              </tr>
            </thead>
            <tbody>
              {deviceSettingChangeHistoryListState?.map((list, index) => (
                <tr key={index}>
                  <td>{(offset + index + 1).toLocaleString()}</td>
                  <td>{list.createdAt}</td>
                  <td>{list.changer}</td>
                  <td>{list.calibrationValue}</td>
                  <td>{list.notificationValue}</td>
                  <td>{list.receptionCycle}시간</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableBox>
        {listLength !== 0 && (
          <Pagenation
            listAllLength={listLength}
            listLimit={limit}
            onCurrentPageChange={handleOffsetChange}
          />
        )}
      </TabCntBox>
      {alarmCorrectionModifyModalState && <AlarmCorrectionModifyModal />}
    </>
  );
};

export default SettingChangeHistory;

export const CntBox1 = styled(CS.CntBoxType1)`
  width: 100%;
`;

export const CntBox2 = styled(CS.CntBoxType1)`
  width: 100%;
  margin-top: 20px;
`;

export const InforWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 16px;
`;

export const InforBox1 = styled(CS.CntBoxType2)`
  position: relative;
  width: calc(50% - 13.3333px);
  > .device-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
`;

export const InforBox2 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .text-wrap {
    &:before {
      display: none;
    }
    > .text-box {
      width: 100%;
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
`;

export const InforBox3 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .img-area {
    width: 100%;
    position: relative;
    margin-top: 12px;
    > button {
      position: absolute;
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border: 1px solid #ececec;
      background: #fff;
      border-radius: 4px;
      left: 10px;
      bottom: 10px;
      > .img-box {
        width: 24px;
      }
    }
  }
`;

export const SearchOptionBox = styled(CS.SearchOptionBox)`
  width: 100%;
  margin-top: 20px;
`;

export const InputWrap = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const InputArea = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > h2 {
    color: #555;
    font-size: 14px;
  }
`;

export const TabCntBox = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const TableOpitonBox = styled(CS.TableOpitonBox)`
  width: 100%;
  margin-top: 0;
`;

export const TableOpitonBox2 = styled(TableOpitonBox)`
  margin-top: 32px;
`;

export const TableBox = styled(CS.TableType1)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const MapBox = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`;

export const MapModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  width: 136px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  > .title-box {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #e9e8e8;
    font-size: 16px;
    font-weight: 500;
  }
  > .text-box {
    box-sizing: border-box;
    padding: 12px;
    background: #fff;
    > .state-box {
      display: flex;
      align-items: center;
      gap: 8px;
      > .text {
        font-size: 15px;
      }
      > .line {
        width: 1px;
        height: 10px;
        background: #d9d9d9;
      }
    }
    > .date {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 300;
      color: #777;
    }
    > button {
      margin-top: 8px;
      font-size: 14px;
      color: #3c8deb;
    }
  }
`;

export const MapTextModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 70%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  padding: 10px 16px;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff;
  > p {
    font-size: 15px;
    white-space: nowrap;
  }
  > button {
    width: 10px;
    min-width: 10px;
  }
`;

export const GraphBox = styled.div`
  margin-top: 16px;
  width: 100%;
  height: 280px;
  box-sizing: border-box;
  border-top: 2px solid #222222;
`;
